export default {
  "common": {
    "accessManagement": "Gestão de Acesso",
    "action": "Ação",
    "actions": "Ações",
    "activate_link": "Ativar link",
    "active": "Ativo",
    "add_column": "Adicionar coluna",
    "add_dependency": "Adicionar dependência",
    "add_field": "Adicionar campo",
    "add_group": "Adicionar Grupo",
    "add_group_feature_description": "Selecione o grupo que deseja adicionar a funcionalidade",
    "add_group_feature_title": "Adicionar grupo a funcionalidade",
    "add_initiative": "Adicionar iniciativa",
    "add_one_option_per_line": "Adicione uma opção por linha",
    "add_option": "Adicionar opção",
    "add_permission": "Adicionar permissão",
    "add_question": "Adicionar pergunta",
    "add_related_field": "Adicionar campo relacionado",
    "add_row": "Adicionar linha",
    "add_rule": "Adicionar regra",
    "add_section": "Adicionar seção",
    "add_to_group": "Adicionar a um grupo",
    "add_user": "Adicionar Usuário",
    "add_user_feature_description": "Selecione o usuário que deseja adicionar a funcionalidade",
    "add_user_feature_title": "Adicionar usuário a funcionalidade",
    "add_user_to_group": "Adicionar usuário ao grupo",
    "add_user_to_initiative": "Adicionar usuário a iniciativa",
    "add_workflow": "Adicionar Workflow",
    "added_at": "Adicionado em",
    "administrators": "Administradores",
    "alias": "Alias",
    "alias_format": "O alias deve conter apenas letras minúsculas, números ou underline",
    "alias_invalid_reserved_word": "Alias inválido. Não pode ser uma palavra reservada.",
    "alias_max_length": "O alias deve ter no máximo 100 caracteres",
    "alias_min_length": "O alias deve ter no mínimo 3 caracteres",
    "allow_others": "Adicionar outros?",
    "and": "E",
    "apply_rules": "Aplicar regras",
    "attributes": "Atributos",
    "back_to_feature": "Voltar para Funcionalidade",
    "back_to_home": "Voltar para o início",
    "back_to_initiative": "Voltar para iniciativa",
    "begins_with": "Começa com",
    "between": "Entre",
    "both_filters_cannot_be_empty": "Ambos os filtros não podem estar vazios",
    "business": "Negócio",
    "business_created_successfully": "Negócio criado com sucesso.",
    "business_data": "Dados do negócio",
    "business_name": "Nome do negócio",
    "business_required": "É necessário informar o nome do negócio",
    "business_updated_successfully": "Negócio atualizado com sucesso.",
    "businesses": "Negócios",
    "cancel": "Cancelar",
    "cannot_remove_last_section": "Você não pode excluir a única seção.",
    "cannot_save_empty_filter": "Não é possível salvar um filtro vazio",
    "cannot_save_empty_form": "Não é possível salvar formulário vazio",
    "change_password": "Alterar senha",
    "change_user_password": "Alterar senha do usuário",
    "change_user_password_description": "Crie uma senha temporária para o usuário, essa senha deverá ser trocada no próximo login.",
    "choose_an_attribute_from_the_list_above": "Escolha um campo da lista acima",
    "choose_field_from_table": "Escolha um campo da tabela de dados",
    "choose_layout_link": "Escolha o layout para o qual deseja criar o link:",
    "clean_unsaved_collect": "Limpar coleta não salva",
    "CNPJ_invalid": "O CNPJ informado é inválido.",
    "CNPJ_max_length_18": "O CNPJ deve ter no máximo 18 caracteres.",
    "CNPJ_min_length_18": "O CNPJ deve ter no mínimo 18 caracteres.",
    "CNPJ_required": "O CNPJ é obrigatório",
    "collect": "Coleta",
    "collect_back_button": "Anterior",
    "collect_concluded_button": "Concluir formulário",
    "collect_finished": "A coleta foi finalizada com sucesso.",
    "collect_next_button": "Próxima seção",
    "collect_section_paginate": "Seção",
    "collect_section_paginate_separator": "de",
    "collect_versions": "Versões da coleta",
    "collects": "Coletas",
    "column_size": "Tamanho da coluna",
    "condition": "Condição",
    "condition_contains": "Contém",
    "condition_equal": "Igual",
    "condition_greater_than": "Maior que",
    "condition_less_than": "Menor que",
    "condition_multiple": "Múltiplo",
    "configurations": "Configurações",
    "configure_attribute": "Configurar atributo",
    "confirm": "Confirmar",
    "confirm_action": "Confirmar troca de status",
    "confirm_delete_feature": "Tem certeza que deseja excluir esta funcionalidade?",
    "confirm_password": "Confirme a senha",
    "confirm_remove_row_description": "Deseja realmente remover esta linha? Os campos contidos nela serão removidos.",
    "confirm_remove_section_description": "Deseja realmente remover esta seção? Os campos contidos nela serão removidos.",
    "connect_question": "Conectar a pergunta",
    "consent_text_min_length": "O texto de consentimento deve ter no mínimo 5 caracteres.",
    "consent_text_required": "É necessário informar o texto de consentimento",
    "contains": "Contém",
    "contains_file": "Contém arquivo",
    "CPF_invalid": "O CPF informado é inválido.",
    "CPF_min_length_11": "O CPF deve ter no mínimo 11 caracteres.",
    "create": "Criar",
    "create_business": "Criar Negócio",
    "create_field": "Criar campo",
    "create_group": "Criar grupo",
    "create_initiative": "Criar iniciativa",
    "create_user": "Criar usuário",
    "created_at": "Criado em",
    "created_by": "Criado por",
    "currency_symbol": "R$",
    "custom_fields": "Campos personalizados",
    "customize_layout_attributes": "Customizar layout e atributos",
    "dashboard": "Dashboard",
    "dashboard_link": "Link do dashboard",
    "dashboard_link_placeholder": "https://app.powerbi.com/exemplo",
    "data_collection": "Coleta de dados",
    "data_information": "Dados e informações",
    "data_source": "Fonte de dados",
    "data_table": "Tabela de dados",
    "date_invalid": "A data deve estar no formato dd/mm/aaaa",
    "DateTime_invalid": "A data e hora devem estar no formato dd/mm/aaaa HH:mm",
    "deactivate_link": "Desativar link",
    "define_super_admin_permissions": "Definir permissões de super admin",
    "delete": "Excluir",
    "delete_attribute": "Excluir atributo",
    "delete_collect": "Você realmente deseja deletar esta coleta?",
    "delete_dependency": "Excluir dependência",
    "delete_feature": "Excluir Funcionalidade",
    "delete_feature_confirmation_label": "Sim, eu entendo e quero deletar essa funcionalidade",
    "delete_feature_warning": "Atenção: Esta ação é irreversível. Todos os dados vinculados a esta funcionalidade serão removidos permanentemente.",
    "delete_initiative": "Deletar iniciativa",
    "delete_initiative_confirmation": "Deseja realmente excluir esta iniciativa?",
    "delete_option": "Deletar opção",
    "delete_permission": "Deletar permissão",
    "delete_workflow": "Excluir workflow",
    "delete_workflow_description": "Você tem certeza que deseja excluir este workflow?",
    "dependencies": "Dependências",
    "dependencies_count_one": "dependência ({{count}})",
    "dependencies_count_many": "dependências ({{count}})",
    "dependencies_count_other": "dependências ({{count}})",
    "description": "Descrição",
    "description_length_invalid": "A descrição deve ter entre 3 e 800 caracteres",
    "description_max_length": "A descrição deve ter no máximo 800 caracteres",
    "Description_max_length_3_800": "A descrição deve ter entre 3 e 800 caracteres",
    "description_min_length": "A descrição deve ter no mínimo 3 caracteres",
    "description_min_length_3_800": "Descrição deve ter no mínimo 3 caracteres e no máximo 800 caracteres",
    "description_required": "A descrição é obrigatória",
    "destination_initiative_required": "É necessário selecionar uma iniciativa de destino para duplicar.",
    "destination_required": "O destino é obrigatório",
    "disable_portfolio": "Desativar portfólio",
    "do_you_really_want_to_remove_the_group": "Deseja realmente remover o grupo?",
    "download_template": "Download do Template",
    "draft_saved": "Rascunho salvo",
    "drag_and_drop_file": "Arraste e solte o arquivo",
    "duplicate_feature": "Duplicar Funcionalidade",
    "duplicate_initiative": "Duplicar Iniciativa",
    "duplicate_section_title": "Já existe uma seção com este título.",
    "edit": "Edição",
    "edit_and_delete": "Edição e Exclusão",
    "edit_feature": "Editar Funcionalidade",
    "edit_initiative": "Editar iniciativa",
    "edit_portfolio": "Editar portfólio",
    "edit_user": "Editar usuário",
    "email": "Email",
    "email_body": "Corpo do email",
    "email_invalid": "Email inválido",
    "email_required": "Email é obrigatório",
    "empty_layout": "Layout vazio",
    "enable_portfolio": "Ativar portfólio",
    "enabled_required": "É necessário informar se o usuário está ativo",
    "end": "Fim",
    "end_date": "Data final",
    "ends_with": "Termina com",
    "enter_email": "Insira o email",
    "enter_email_body": "Insira o corpo do email",
    "enter_field_description": "Digite uma descrição para o campo",
    "enter_field_name": "Digite o nome do campo",
    "enter_new_password": "Digite a nova senha",
    "enter_option_name": "Digite o nome da opção",
    "equals": "É igual a",
    "error": "Erro",
    "exampleEmail {{verb}} {{feature}}": "O seguinte email já é enviado por padrão, o que você escrever nesse campo será mandado ao fim dessa mensagem:\nUma coleta com o ID # foi {{verb}} para a funcionalidade {{feature}}.",
    "executed_at": "Executado em",
    "exit": "Sair",
    "export_data": "Exportação de dados",
    "export_data_success": "Solicitação de exportação feita com sucesso.",
    "export_files": "Exportar arquivos das coletas",
    "exports": "Exportações",
    "feature": "Funcionalidade",
    "feature_created_successfully": "Funcionalidade criada com sucesso.",
    "feature_data": "Dados da Funcionalidade",
    "feature_enabled": "Funcionalidade Ativa",
    "feature_name": "Nome da Funcionalidade",
    "feature_published": "Funcionalidade publicada",
    "feature_updated_error": "Erro ao atualizar funcionalidade",
    "feature_updated_success": "Funcionalidade atualizada com sucesso.",
    "features": "Funcionalidades",
    "field": "Campo",
    "field_created_successfully": "Campo criado com sucesso.",
    "field_description_max_length": "A descrição do campo deve ter no máximo 500 caracteres.",
    "field_name_max_length": "O nome do campo deve ter no máximo 250 caracteres.",
    "field_placeholder": "Campo...",
    "field_required": "O campo é obrigatório",
    "field_type_BIG_INT": "Número inteiro",
    "field_type_DATE": "Data",
    "field_type_DATETIME": "Data e hora",
    "field_type_DECIMAL": "Número decimal",
    "field_type_FILE": "Arquivo",
    "field_type_GEOGRAPHICAL_MULTIPLE_POINT": "Múltiplos pontos geográficos",
    "field_type_GEOGRAPHICAL_POINT": "Ponto geográfico",
    "field_type_GEOGRAPHICAL_POLYGON": "Polígono geográfico",
    "field_type_GEOGRAPHICAL_ROUTE": "Rota geográfica",
    "field_type_IMPORT_FIELD": "Importar uma funcionalidade",
    "field_type_INFO_TEXT": "Texto informativo",
    "field_type_LONG_TEXT": "Texto longo",
    "field_type_MATRIZ": "Matriz",
    "field_type_MULTIPLE_LIST": "Caixa de seleção múltipla",
    "field_type_required": "É necessário informar o tipo do campo",
    "field_type_TERM": "Termo de consentimento",
    "field_type_TEXT": "Texto curto",
    "field_type_TIME": "Hora",
    "field_type_UNIQUE_LIST": "Caixa de seleção única",
    "fields_to_export": "Campos a serem exportados",
    "file": "Arquivo",
    "file_cannot_be_null_select_file": "O arquivo não pode ser nulo. Por favor, selecione um arquivo para upload.",
    "filter_business": "Filtrar por negócio",
    "filter_by_feature": "Filtrar por Funcionalidade",
    "finished_count": "Finalizadas",
    "finished_rate": "Taxa de Finalização",
    "generate_link": "Gerar link",
    "generated_automatically": "Gerado automaticamente",
    "greater_than_or_equal_to": "Maior ou igual a",
    "group": "Grupo",
    "group_added_successfully": "Grupo adicionado com sucesso.",
    "group_created_successfully": "Grupo criado com sucesso.",
    "group_data": "Dados do grupo",
    "group_edited_successfully": "Grupo editado com sucesso.",
    "group_name": "Nome do grupo",
    "group_required": "O grupo é obrigatório",
    "groups": "Grupos",
    "if_the_answer_is": "Se a resposta for",
    "image_exceeded_size_limit": "A imagem excedeu o limite de tamanho de {{size}}mb.",
    "import_data_success": "Importação de dados realizada com sucesso.",
    "import_file": "Arquivo de importação",
    "import_finish": "Concluir",
    "import_line_max_length": "As linhas devem ter no máximo 255 caracteres.",
    "import_options": "Importar opções",
    "imported_data": "Importação de dados",
    "imports": "Importações",
    "inactive": "Inativo",
    "info_text_min_length": "A descrição do campo deve ter no mínimo 1 caractere.",
    "info_text_required": "É necessário informar a descrição do campo",
    "initiative": "Iniciativa",
    "initiative_created_successfully": "Iniciativa criada com sucesso.",
    "initiative_deleted_successfully": "Iniciativa excluída com sucesso.",
    "initiative_edited_successfully": "Iniciativa editada com sucesso.",
    "initiative_name": "Nome da iniciativa",
    "initiative_name_max_length": "O nome da iniciativa deve ter no máximo 50 caracteres.",
    "initiative_successfully_duplicated": "Iniciativa duplicada com sucesso.",
    "initiatives": "Iniciativas",
    "Integer_invalid": "O valor informado deve ser um número inteiro.",
    "invalid_email": "E-mail inválido",
    "invalid_option": "Opção inválida",
    "layout_saved_successfully": "Layout salvo com sucesso.",
    "less_than_or_equal_to": "Menor ou igual a",
    "like_required": "O termo de pesquisa é obrigatório",
    "link": "Vincular",
    "link_collect": "Vincular coleta",
    "link_feature": "Vincular funcionalidade",
    "link_features": "Vincular funcionalidades",
    "linked_features": "Funcionalidades vinculadas",
    "loading_layout": "Carregando Layout...",
    "location": "Localização",
    "logo": "Logo",
    "logo_required": "O logo é obrigatório",
    "lookup": "Pesquisa",
    "main_fields": "Campos principais",
    "manage_groups_permissions": "Gerencie os grupos que possuem permissões sobre essa funcionalidade.",
    "manage_users_permissions": "Gerencie os usuários que possuem permissões sobre essa funcionalidade.",
    "manage_users_with_admin_permissions": "Gerencie os usuários que possuem permissões de super admin.",
    "matrices": "Matrizes",
    "matrix": "Matriz",
    "matrix_fields": "Campos da matriz",
    "matriz_field": "Campo Matriz",
    "matriz-create": "Criar matriz",
    "matriz-delete": "Deletar matriz",
    "matriz-update": "Atualizar matriz",
    "maximum_value": "Valor máximo",
    "min_value_cannot_be_greater_than_max_value": "O valor mínimo não pode ser maior que o valor máximo",
    "minimum_value": "Valor mínimo",
    "mobile": "Mobile",
    "monetary_subtype_not_apply_to_text": "O subtipo monetário não se aplica a texto",
    "name": "Nome",
    "name_max_length": "Nome deve ter no máximo 100 caracteres",
    "name_max_length_100": "O nome deve ter no máximo 100 caracteres",
    "name_min_length": "Nome deve ter no mínimo 3 caracteres",
    "name_min_length_3": "O nome deve ter no mínimo 3 caracteres",
    "name_required": "Nome é obrigatório",
    "new_collect": "Nova coleta",
    "new_export": "Nova exportação",
    "new_feature": "Nova funcionalidade",
    "new_import": "Nova importação",
    "no": "Não",
    "no_attribute_selected": "Nenhum atributo selecionado",
    "no_audits_found": "Nenhuma auditoria encontrada.",
    "no_collect_found": "Nenhuma coleta encontrada",
    "no_collect_links": "Não existem links de coleta para essa funcionalidade. Voltando...",
    "no_data_found": "Nenhum dado encontrado.",
    "no_exports_found": "Nenhuma exportação encontrada.",
    "no_features_found": "Nenhuma funcionalidade encontrada.",
    "no_fields_found": "Nenhum campo encontrado",
    "no_group_permission": "Nenhum grupo tem permissão para essa funcionalidade.",
    "no_groups_found": "Nenhum grupo encontrado",
    "no_imports_found": "Nenhuma importação encontrada.",
    "no_initiatives_found": "Nenhuma iniciativa encontrada",
    "no_linked_features": "Nenhuma funcionalidade vinculada",
    "no_permission": "Sem permissão",
    "no_published_layout_redirect": "Não há nenhum layout publicado para essa funcionalidade. Redirecionando...",
    "no_related_fields_found": "Nenhum campo relacionado encontrado",
    "no_user_permission": "Nenhum usuário tem permissão para essa funcionalidade.",
    "no_users_found": "Nenhum usuário encontrado",
    "no_workflows_found": "Nenhum workflow encontrado",
    "not_authorized": "Acesso não autorizado!",
    "not_collect_found": "Nenhuma coleta encontrada.",
    "not_contains": "Não contém",
    "not_equals": "Não é igual a",
    "notification": "Notificação",
    "on_change_section": "Ao alterar a matriz de referência ou o tipo de seção, as configurações atuais serão perdidas. Tem certeza?",
    "only_images_as_logo": "O negócio aceita apenas imagens do tipo .png, .jpeg, .gif ou .webapp como logo.",
    "open_count": "Aberturas",
    "operator": "Operador",
    "operator_required": "O operador é obrigatório",
    "option": "Opção",
    "option_line_placeholder": "opção 1",
    "option_name_required": "O nome da opção é obrigatório",
    "or": "OU",
    "other": "Outros",
    "page_not_found": "Página não encontrada",
    "page_not_found_description": "A página que você está procurando não existe.",
    "pagination": "Paginação",
    "participants": "Participantes",
    "password": "Senha",
    "password_changed_successfully": "Senha alterada com sucesso.",
    "password_max_length": "Senha deve ter no máximo 40 caracteres",
    "password_min_length": "Senha deve ter no mínimo 4 caracteres",
    "password_required": "Senha é obrigatória",
    "passwords_must_match": "As senhas devem ser iguais",
    "past": {
      "create": "criada",
      "delete": "deletada",
      "update": "atualizada"
    },
    "permission": "Permissão",
    "permission_added_success": "Permissão adicionada com sucesso.",
    "permission_deleted_successfully": "Permissão excluída com sucesso.",
    "permissions_groups": "Permissões de Grupos",
    "permissions_user": "Permissões de Usuários",
    "Phone_max_length_15": "O telefone deve ter no máximo 15 caracteres.",
    "Phone_min_length_14": "O telefone deve ter no mínimo 14 caracteres.",
    "placeholder_editor": "Digite ou cole seu conteúdo aqui!",
    "platform": "Plataforma",
    "Point_invalid": "O valor informado deve ser um número.",
    "Point_invalid_range": "O valor informado deve estar entre 0 e 100.",
    "point_min_length_1": "Deve ser informado pelo menos um ponto",
    "portfolio": "Portfólio",
    "preview_fields": "Campos de pré-visualização",
    "processing": "Processando",
    "publish": "Publicar",
    "redo_collect": "Realizar outra coleta",
    "region_city_or_neighborhood ": "Região, cidade ou bairro",
    "registration": "Cadastro",
    "related_field": "Campo relacionado",
    "remove": "Remover",
    "remove_rule": "Remover regra",
    "remove_user": "Remover usuário",
    "remove_user_from_group": "Remover usuário do grupo",
    "required_field": "Campo obrigatório?",
    "required_matrix": "Matriz obrigatória?",
    "response": "Resposta",
    "response_value": "Valor de resposta",
    "responsible_data": "Dados do responsável",
    "responsible_email": "E-mail do responsável",
    "Responsible_email_invalid": "O e-mail do responsável é inválido",
    "Responsible_email_required": "O e-mail do responsável é obrigatório",
    "responsible_name": "Nome do responsável",
    "responsible_name_max_length": "O nome do responsável deve ter no máximo 255 caracteres.",
    "Responsible_name_max_length_100": "O nome do responsável deve ter no máximo 100 caracteres.",
    "responsible_name_min_length": "O nome do responsável deve ter no mínimo 3 caracteres.",
    "Responsible_name_min_length_3": "O nome do responsável deve ter no mínimo 3 caracteres.",
    "Responsible_name_required": "O nome do responsável é obrigatório",
    "responsible_phone": "Telefone do responsável",
    "responsible_phone_max_length": "O telefone do responsável deve ter no máximo 15 caracteres.",
    "Responsible_phone_max_length_15": "O telefone do responsável deve ter no máximo 15 caracteres.",
    "responsible_phone_min_length": "O telefone do responsável deve ter no mínimo 14 caracteres.",
    "Responsible_phone_min_length_15": "O telefone do responsável deve ter no mínimo 14 caracteres.",
    "Responsible_phone_required": "O telefone do responsável é obrigatório",
    "restore_unsaved_collect": "Foi encontrada uma coleta não salva. Deseja restaurá-la?",
    "return_previous_page": "Voltar para página anterior",
    "return_to_businesses_management": "Voltar para gestão de negócios",
    "return_to_destination": "Voltar para {{destination}}",
    "return_to_group_management": "Voltar para gerenciamento de grupos",
    "return_to_initiative": "Voltar para iniciativa",
    "return_to_initiative_management": "Voltar para gerenciamento de iniciativas",
    "return_to_initiatives": "Voltar para iniciativas",
    "return_to_initiatives_management": "Voltar para gerenciamento de iniciativas",
    "return_to_user_management": "Voltar para gerenciamento de usuários",
    "save": "Salvar",
    "save_changes": "Salvar alterações",
    "saved": "Salvo",
    "saving": "Salvando...",
    "search_collects": "Pesquisar coletas",
    "search_features": "Pesquisar Funcionalidades",
    "search_groups": "Pesquisar grupos",
    "search_in_initiative": "Pesquisar na iniciativa",
    "search_initiative": "Pesquisar iniciativa",
    "search_users": "Pesquisar usuários",
    "section": "Seção",
    "section_image": "Imagem da seção",
    "section_order": "Seção {{order}}",
    "section_required": "A seção é obrigatória",
    "section_title": "Título da seção",
    "sections": "Seções",
    "select": "Selecionar",
    "select_a_feature": "Selecionar uma funcionalidade",
    "select_a_value": "Selecionar um valor",
    "select_action_type": "Selecione o tipo da ação",
    "select_all": "Selecionar todos",
    "select_an_import_file": "Selecionar um arquivo de importação",
    "select_an_option": "Selecionar uma opção",
    "select_at_least_one_item": "Selecione pelo menos um item",
    "select_at_least_one_option": "Selecione pelo menos uma opção",
    "select_attribute": "Selecionar atributo",
    "select_collect_required": "É necessário selecionar uma coleta",
    "select_condition": "Selecione uma condição",
    "select_condition_required": "É necessário selecionar uma condição",
    "select_feature": "Selecione uma funcionalidade",
    "select_feature_required": "É necessário selecionar uma funcionalidade",
    "select_features_to_link": "Você pode selecionar até 3 campos dessa funcionalidade para gerar uma pré-visualização da coleta a ser vinculada.",
    "select_field": "Selecione um campo",
    "select_field_min_options": "O campo de seleção deve ter no mínimo duas opções.",
    "select_field_subtype": "Selecione o subtipo",
    "select_field_type": "Selecione o tipo do campo",
    "select_filters": "Selecionar filtros",
    "select_group_placeholder": "Selecione um grupo",
    "select_group_required": "É necessário selecionar um grupo",
    "select_initiative": "Selecione uma iniciativa",
    "select_initiative_required": "É necessário selecionar uma iniciativa",
    "select_matriz_field": "Selecione o campo matriz",
    "select_max_three_fields": "Selecione no máximo 3 campos",
    "select_permission": "Selecione a permissão",
    "select_permission_level": "Selecione o nível de permissão",
    "select_platform_required": "É necessário selecionar uma plataforma",
    "select_preview_fields_tooltip": "Selecione os campos que deseja exibir na pré-visualização",
    "select_the_group_you_want_to_add_the_user_to": "Selecione o grupo que deseja adicionar o usuário",
    "select_user": "Selecione o usuário",
    "select_user_placeholder": "Selecione um usuário",
    "select_user_required": "É necessário selecionar um usuário",
    "select_user_to_add_to_group": "Selecione o usuário que deseja adicionar ao grupo",
    "select_user_to_add_to_initiative": "Selecione o usuário que deseja adicionar a iniciativa",
    "selected_items": "itens selecionados",
    "self_applied_link": "Link de Autoaplicação",
    "sensitive_data": "Dado sensível",
    "start": "Inicio",
    "start_date": "Data inicial",
    "start_date_cannot_be_greater_than_end_date": "A data de início não pode ser maior que a data de fim",
    "start_write_count": "Iniciadas",
    "status": "Status",
    "status_feature_updated_successfully": "Status da funcionalidade {{featureName}} atualizado com sucesso",
    "strict_section_navigate": "Navegação estrita entre seções",
    "sub_type": "Subtipo",
    "subtype_CNPJ": "CNPJ",
    "subtype_CPF": "CPF",
    "subtype_MAIL": "E-mail",
    "subtype_MONEY_VALUE": "Valor monetário",
    "subtype_PHONE": "Telefone",
    "subtypes_not_apply_to_decimal": "O subtipos não se aplicam a decimal",
    "success": "Sucesso",
    "successfully_duplicated": "Duplicado com sucesso",
    "successfully_removed": "Removido com sucesso",
    "super_admin": "Super administrador",
    "super_admin_business_required": "Informe o nível de permissão do negócio",
    "super_admin_initiative_required": "Informe o nível de permissão da iniciativa",
    "super_admin_permissions": "Permissões de super admin",
    "super_admin_required": "É necessário informar se o usuário é super administrador",
    "super_admin_user_required": "Informe o nível de permissão do usuário",
    "template_and_import": "Template e importação",
    "text_max_length_255": "O texto deve ter no máximo 255 caracteres.",
    "text_max_length_3000": "O texto deve ter no máximo 3000 caracteres.",
    "text_min_length_1": "O texto deve ter no mínimo 1 caractere.",
    "text_min_length_3": "O texto deve ter no mínimo 3 caracteres.",
    "this_action_cannot_be_undone": "Essa ação não pode ser desfeita.",
    "time_format_expected": "Formato de hora inválido",
    "Time_invalid": "Hora inválida",
    "title_initiative_data": "Dados da iniciativa",
    "trigger": "Gatilho",
    "trigger_type": "Tipo de Gatilho",
    "trigger_type_required": "O tipo de gatilho é obrigatório",
    "type": "Tipo",
    "type_required": "O tipo é obrigatório",
    "update": "Atualizar",
    "update_version": "Atualizar versão",
    "update_version_confirm_description": "Tem certeza que deseja atualizar a versão da funcionalidade? Esta ação poderá adicionar novas validações ou remover campos previamente cadastrados.",
    "upload": "Upload",
    "user": "Usuário",
    "user_added_successfully": "Usuário adicionado com sucesso.",
    "user_created_successfully": "Usuário criado com sucesso.",
    "user_data": "Dados do usuário",
    "user_edited_successfully": "Usuário editado com sucesso.",
    "user_removed_from_group_successfully": "Usuário removido do grupo com sucesso.",
    "user_required": "O usuário é obrigatório",
    "user_status": "Status do usuário",
    "users": "Usuários",
    "users_found": "Nenhum usuário encontrado",
    "valid_link_required": "É necessário informar um link válido",
    "valid_powerbi_link_required": "É necessário informar um link válido do Power BI",
    "value": "Valor",
    "value_must_be_a_number": "O valor deve ser um número",
    "value_required": "É necessário informar um valor",
    "version": "Versão",
    "view": "Visualização",
    "view_analytics": "Visualizar estatísticas",
    "view_version": "Visualizar Versão",
    "view_workflow": "Visualizar workflow",
    "waiting": "Aguardando",
    "web": "Web",
    "workflow_deleted_successfully": "Workflow excluído com sucesso",
    "workflows": "Workflows",
    "yes": "Sim",
    "you_can_create_link": "Você pode criar um link público para coletar respostas de forma online."
  },
  "initiative": {},
  "features": {},
  "translation": {}
} as const;
